import { Component, HostListener, OnDestroy, OnInit } from '@angular/core'
import { SharedServices } from '../../../../../../services/shared.services'
import { AuthService } from '../../../../../../services/auth.services'
import { FormBuilder } from '@angular/forms'
import { RestServices } from '../../../../../../services/rest.services'
import { ModalService } from '../../../../../../services/modal.service'
import { ClientTopServices } from '../../../../../../services/ClientTop.services'
import * as $ from 'jquery'

@Component({
    selector: 'app-modal-client-detail-slideshow-movie',
    templateUrl: './modal-client-detail-slideshow-movie.component.html',
    styleUrls: [
        './modal-client-detail-slideshow-movie.component.css',
        '../../../../../../stagingcss/image-viewer.component.css',
        '../../../../../../stagingcss/root-ui-view.component.css',
        '../../../../../../stagingcss/ui-schema-table-form.component.css',
        '../../../../../../stagingcss/main-body.component.css',
        '../../../../../../stagingcss/lui-select.component.css',
    ],
})
export class ModalClientDetailSlideshowMovieComponent implements OnInit, OnDestroy {
    en: any = {}
    showEN: Boolean = true
    option_SlideshowMovie: String = 'active'
    TabSlideshowMovieClass
    status: Boolean = false

    arrTabSlideshowOther = [
        { id: 0, name: 'All', nameSave: 'Registration-All' },
        { id: 1, name: '1', nameSave: 'Registration-Tooth-Front-Right' },
        { id: 2, name: '2', nameSave: 'Registration-Tooth-Front-Front' },
        { id: 3, name: '3', nameSave: 'Registration-Tooth-Side-Left' },
        { id: 4, name: '4', nameSave: 'Registration-Tooth-Side-Upper' },
        { id: 5, name: '5', nameSave: 'Registration-Tooth-Overjet' },
        { id: 6, name: '6', nameSave: 'Registration-Tooth-Lower' },
    ]
    arrSlideshowMovie: any[] = []
    arrAllMovie: any[] = []
    jsonMovie: any = {}
    arrShowStatus: any[] = []
    index: any = 0
    tabName: any = 'movie-all'
    width: any
    height: any
    imageAddHeight: any
    imageAddWidth: any

    option_Slideshow: any = 'hidden'
    senMax: any = 100
    max: any = 0
    valChange: any = 0
    emitTabName: any = {}
    animationDuration: any = 300
    arrLoading: any[] = []
    ValueAssignOneDistance: any = 0
    getInfoIndex = undefined
    page = 'slideshow'
    unscrPage
    unscrAllArrClientTop
    unscrIndex

    constructor(private _sharedService: SharedServices,
                private authData: AuthService,
                private restApi: RestServices,
                private formBuider: FormBuilder,
                private modalService: ModalService,
                private clientTopServices: ClientTopServices) {
        this.option_SlideshowMovie = 'active'
        this.TabSlideshowMovieClass = 'option_0'
        this.option_Slideshow = 'active'
    }

    ngOnInit() {
        this.arrLoading = [true, true, true, true, true, true]
        this.clientTopServices.changeEmittedTabName$.subscribe(infoTabName => {
            if (infoTabName != null && infoTabName['tabName'] != undefined) {
                this.tabName = infoTabName['tabName']
            } else {
                this.tabName = 'movie-all'
            }
            const tmpStr: String = this.tabName
            if (tmpStr.includes('movie')) {
                this.getArrClientTop()
            }
        })

        this.clientTopServices.changeEmittedStatus$.subscribe(res => {
            if (res != null && res['status'] != undefined) {
                this.status = res['status']
            } else {
                this.status = false
            }
        })
        if ($(window).innerWidth() != window.screen.width) {
            this.width = ($(window).innerWidth() - 300) / 3
            this.height = 2 * this.width / 3
        } else if ($(window).innerHeight() != window.screen.height) {
            const tmpH = $(window).innerHeight()
            this.height = (tmpH - 300) / 2
            this.width = this.height * 3 / 2
        }
        this.imageAddHeight = this.height / 6
        this.imageAddWidth = this.width / 6
        // this.getValueSlider();
        this.resizeUser()
        this.getPage()
    }

    ngOnDestroy() {
        this.getInfoIndex = undefined
        if(this.unscrPage)
            this.unscrPage.unsubscribe()
        if(this.unscrAllArrClientTop)
            this.unscrAllArrClientTop.unsubscribe()
        if(this.unscrIndex)
            this.unscrIndex.unsubscribe()
    }

    getPage() {
        this.unscrPage = this.clientTopServices.changeEmiitedPage$.subscribe(res => {
            if (res) {
                this.page = res
            }
        })
    }

    resizeUser() {
        this.clientTopServices.changeEmittedViewDetailUser$.subscribe(status => {
            if (status != null && status['status'] != undefined) {
                const tmp: any = status['status']
                if (tmp == 'in') {
                    if ($(window).innerWidth() != window.screen.width) {
                        const tmpW = $(window).innerWidth()
                        this.width = (tmpW - 300) / 3
                        this.height = this.width * 2 / 3
                    } else if ($(window).innerHeight() != window.screen.height) {
                        const tmpH = $(window).innerHeight()
                        this.height = (tmpH - 500) / 2
                        this.width = this.height * 3 / 2
                    } else {
                        const tmpH = $(window).innerHeight()
                        this.height = (tmpH - 500) / 2
                        this.width = this.height * 3 / 2
                    }
                } else {
                    if ($(window).innerWidth() != window.screen.width) {
                        const tmpW = $(window).innerWidth()
                        this.width = (tmpW - 300) / 3
                        this.height = this.width * 2 / 3
                    } else if ($(window).innerHeight() != window.screen.height) {
                        const tmpH = $(window).innerHeight()
                        this.height = (tmpH - 300) / 2
                        this.width = this.height * 3 / 2
                    }
                }
            }
        })
    }

    actionVideo(index) {
        const video: any = document.getElementById('video' + index)
        if (video != undefined && video.paused) {
            video.play()
        } else if (video != undefined && video.played) {
            video.pause()
        }
    }

    getArrClientTop() {
        this.getDataIndex()
        this.getDataShow()
    }

    getDataIndex() {
        this.unscrIndex = this.clientTopServices.changeEmittedIndex$.subscribe(infoIndex => {
            const tmpStr: String = this.tabName
            if (infoIndex != null && infoIndex['index'] != undefined && this.page == 'slideshow') {
                this.index = infoIndex['index']
                this.arrShowStatus = []
                this.getInfoIndex = jQuery.extend(true, {}, infoIndex)
                if (tmpStr.includes('movie') && this.arrAllMovie.length > 0) {
                    this.max = this.arrAllMovie.length - 1
                    if (this.max > 0) {
                        this.ValueAssignOneDistance = this.senMax / this.max
                        this.valChange = this.ValueAssignOneDistance * this.index
                    } else {
                        this.valChange = 0
                    }
                    if (this.arrAllMovie[this.index] != undefined) {
                        this.arrLoading = [false, false, false, false, false, false]
                        this.jsonMovie = this.arrAllMovie[this.index]
                        this.initjsonMovie(this.arrAllMovie[this.index])
                    }
                }
            }
        })
    }

    getDataShow() {
        this.unscrAllArrClientTop = this.clientTopServices.changeEmittedAllArrClientTo$.subscribe(arrAll => {
            if (arrAll != null && arrAll['slideshow'] != undefined && arrAll['slideshow'].length > 0) {
                const tmpStr: String = this.tabName
                if (this.page == 'slideshow') {
                    this.arrAllMovie = arrAll['slideshow']
                    if (tmpStr.includes('movie')) {
                        if (this.arrAllMovie.length > 0 && this.getInfoIndex) {
                            this.max = this.arrAllMovie.length - 1
                            if (this.max > 0) {
                                this.ValueAssignOneDistance = this.senMax / this.max
                                this.valChange = this.ValueAssignOneDistance * this.index
                            } else {
                                this.valChange = 0
                            }
                            if (this.arrAllMovie[this.index] != undefined) {
                                this.arrLoading = [false, false, false, false, false, false]
                                this.jsonMovie = this.arrAllMovie[this.index]
                                this.initjsonMovie(this.arrAllMovie[this.index])
                            }
                        }
                    }
                }
            } else {
                this.valChange = 0
                this.arrLoading = [false, false, false, false, false, false]
                this.arrSlideshowMovie = [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
                this.getShowStatus(this.arrSlideshowMovie)
            }
        })
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        if (event.target.innerWidth != window.screen.width) {
            const tmpW = event.target.innerWidth
            this.width = (tmpW - 300) / 3
            this.height = this.width * 2 / 3
        } else if (event.target.innerHeight != window.screen.height) {
            const tmpH = event.target.innerHeight
            this.height = (tmpH - 300) / 2
            this.width = this.height * 3 / 2
        }
    }

    // getValueSlider() {
    //   this.clientTopServices.changeEmittedValueSlider$.subscribe(res => {
    //     if (res != null && res['sliderClientTop'] != undefined) {
    //       this.valChange = res['sliderClientTop'];
    //     }
    //   });
    // }

    changeValueEx1SliderRegister(valueUsageChange) {
        const value: any = valueUsageChange
        if (this.max > 0) {
            const tmp: number = (value / this.senMax) * this.max
            this.index = Math.round(tmp)
            const tmpEarch: number = this.senMax / this.max
            const assignCalculate = Math.round(tmpEarch)
            const assign = this.index * assignCalculate
            if (this.arrAllMovie[this.index] != undefined) {
                this.jsonMovie = this.arrAllMovie[this.index]
                this.initjsonMovie(this.jsonMovie)
                this.arrSlideshowMovie = this.jsonMovie[this.tabName]
            }
            this.valChange = assign
            const valueSlider: any = {}
            valueSlider['sliderClientTop'] = valueUsageChange
            this.clientTopServices.emitChangeSlider(valueSlider)
        } else {
            this.index = 0
            this.valChange = 0
            if (this.arrAllMovie[this.index] != undefined) {
                this.jsonMovie = this.arrAllMovie[this.index]
                this.initjsonMovie(this.jsonMovie)
                this.arrSlideshowMovie = this.jsonMovie[this.tabName]
            }
            const valueSlider: any = {}
            valueSlider['sliderClientTop'] = 0
            this.clientTopServices.emitChangeSlider(valueSlider)
        }
    }


    initjsonMovie(json) {
        this.jsonMovie['face-1'] = (json['face-1'] != undefined) ? json['face-1'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['face-2'] = (json['face-2'] != undefined) ? json['face-2'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['face-3'] = (json['face-3'] != undefined) ? json['face-3'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['face-4'] = (json['face-4'] != undefined) ? json['face-4'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['face-5'] = (json['face-5'] != undefined) ? json['face-5'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['face-6'] = (json['face-6'] != undefined) ? json['face-6'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['face-all'] = (json['face-all'] != undefined) ? json['face-all'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]

        this.jsonMovie['other-1'] = (json['other-1'] != undefined) ? json['other-1'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['other-2'] = (json['other-2'] != undefined) ? json['other-2'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['other-3'] = (json['other-3'] != undefined) ? json['other-3'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['other-4'] = (json['other-4'] != undefined) ? json['other-4'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['other-5'] = (json['other-5'] != undefined) ? json['other-5'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['other-6'] = (json['other-6'] != undefined) ? json['other-6'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['other-all'] = (json['other-all'] != undefined) ? json['other-all'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]

        this.jsonMovie['movie-1'] = (json['movie-1'] != undefined) ? json['movie-1'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['movie-2'] = (json['movie-2'] != undefined) ? json['movie-2'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['movie-3'] = (json['movie-3'] != undefined) ? json['movie-3'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['movie-4'] = (json['movie-4'] != undefined) ? json['movie-4'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['movie-5'] = (json['movie-5'] != undefined) ? json['movie-5'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['movie-6'] = (json['movie-6'] != undefined) ? json['movie-6'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['movie-all'] = (json['movie-all'] != undefined) ? json['movie-all'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]

        this.jsonMovie['xp-1'] = (json['xp-1'] != undefined) ? json['xp-1'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['xp-2'] = (json['xp-2'] != undefined) ? json['xp-2'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['xp-3'] = (json['xp-3'] != undefined) ? json['xp-3'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['xp-4'] = (json['xp-4'] != undefined) ? json['xp-4'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['xp-5'] = (json['xp-5'] != undefined) ? json['xp-5'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['xp-6'] = (json['xp-6'] != undefined) ? json['xp-6'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['xp-all'] = (json['xp-all'] != undefined) ? json['xp-all'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]

        this.jsonMovie['tooth-right'] = (json['tooth-right'] != undefined) ? json['tooth-right'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['tooth-front'] = (json['tooth-front'] != undefined) ? json['tooth-front'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['tooth-left'] = (json['tooth-left'] != undefined) ? json['tooth-left'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['tooth-upper'] = (json['tooth-upper'] != undefined) ? json['tooth-upper'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['tooth-overjet'] = (json['tooth-overjet'] != undefined) ? json['tooth-overjet'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['tooth-lower'] = (json['tooth-lower'] != undefined) ? json['tooth-lower'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['tooth-all'] = (json['tooth-all'] != undefined) ? json['tooth-all'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]

        this.jsonMovie['aligner-right'] = (json['aligner-right'] != undefined) ? json['aligner-right'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['aligner-front'] = (json['aligner-front'] != undefined) ? json['aligner-front'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['aligner-left'] = (json['aligner-left'] != undefined) ? json['aligner-left'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['aligner-upper'] = (json['aligner-upper'] != undefined) ? json['aligner-upper'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['aligner-overjet'] = (json['aligner-overjet'] != undefined) ? json['aligner-overjet'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['aligner-lower'] = (json['aligner-lower'] != undefined) ? json['aligner-lower'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonMovie['aligner-all'] = (json['aligner-all'] != undefined) ? json['aligner-all'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.getArrSlideshowMovie(this.jsonMovie)
    }

    getArrSlideshowMovie(arrTooth) {
        this.arrSlideshowMovie = arrTooth[this.tabName]
        this.getShowStatus(this.arrSlideshowMovie)
        if (this.arrSlideshowMovie && this.arrSlideshowMovie.length > 0) {
            this.arrSlideshowMovie.forEach((el, i) => {
                if (el != undefined && el['id'] != '') {
                    setTimeout(function() {
                        const video: any = document.getElementById('video' + i)
                        if (video != undefined && video.paused) {
                            video.play()
                        }
                    }, 1000)
                    setTimeout(function() {
                        const video: any = document.getElementById('video' + i)
                        if (video != undefined && video.played) {
                            video.pause()
                            video.currentTime = 0
                        }
                    }, 1050)
                }
            })
        }
    }

    toggleTabRegistrationMovieItem(id, event) {
        this.TabSlideshowMovieClass = id
        switch (id) {
            case 'option_0':
                this.tabName = 'movie-all'
                break
            case 'option_1':
                this.tabName = 'movie-1'
                break
            case 'option_2':
                this.tabName = 'movie-2'
                break
            case 'option_3':
                this.tabName = 'movie-3'
                break
            case 'option_4':
                this.tabName = 'movie-4'
                break
            case 'option_5':
                this.tabName = 'movie-5'
                break
            case 'option_6':
                this.tabName = 'movie-6'
                break
        }
        this.emitTabName['tabName'] = this.tabName
        this.arrSlideshowMovie = this.jsonMovie[this.tabName]
        this.clientTopServices.emitChangeTabName(this.emitTabName)
        this.getShowStatus(this.arrSlideshowMovie)
    }

    getShowStatus(arr: any[] = []) {
        this.arrShowStatus = []
        if (arr && arr.length > 0) {
            arr.forEach(el => {
                if (el != undefined && el['id'] != '') {
                    this.arrShowStatus.push(true)
                } else {
                    this.arrShowStatus.push(false)
                }
            })
        }
    }

    getUrlImage(item, url) {
        if (url == '') {
            if (undefined !== this.arrSlideshowMovie && this.arrSlideshowMovie.length > 0) {
                const tmp: any = this.arrSlideshowMovie[item]
                if (tmp != undefined && tmp['id'] != '') {
                    return tmp['id']
                }
            }
            return ''
        } else {
            return url
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/app_manager/modal/client-detail/top/slideshow/slideshowMovie/modal-client-detail-slideshow-movie.component.ts